<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="big">100</span> <span class="normal">BUTTERCREAM <i>Flowers</i></span></h1>
<h2 class="author">Valeri Valeriano &amp; Christina Ong</h2>
<h2 class="sub-title">THE COMPLETE STEP-BY-STEP GUIDE TO PIPING FLOWERS IN BUTTERCREAM ICING</h2>
<p class="web"><a href="http://www.stitchcraftcreate.co.uk" target="_blank">www.stitchcraftcreate.co.uk</a></p>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?73e7c87c